import moment from "moment";
import { api } from "common";
import { Column } from "material-table";
import { IPlanType } from "common/src/types";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { CustomMaterialTable } from "components/CustomMaterialTable";

export default function Plans() {
    const { editPlans } = api;
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const plans = useSelector((state) => state.plans);
    const settings = useSelector((state) => state.settingsdata.settings);

    const columns: Column<IPlanType>[] = [
        {
            field: "createdAt",
            editable: "never",
            defaultSort: "desc",
            title: t("createdAt"),
            render: (rowData) =>
                moment(rowData.createdAt).format("lll"),
        },
        {
            field: "active",
            type: "boolean",
            title: t("active_status"),
        },
        {
            type: "boolean",
            field: "isPopular",
            title: t("POPULAR").toLocaleLowerCase(),
        },
        {
            field: "order",
            type: "numeric",
            title: t("order"),
            validate: rowData =>
                rowData.days && !isNaN(rowData.days) && rowData.days > 0
                    ? true
                    : t("positive_required")
        },
        {
            field: "title",
            type: "string",
            title: t("title"),
            validate: rowData => rowData.title ? true : t("required")
        },
        {
            type: "string",
            field: "description",
            title: t("description"),
            validate: rowData => rowData.description ? true : t("required")
        },
        {
            type: "string",
            field: "features1",
            title: t("features1"),
            validate: rowData => rowData.features1 ? true : t("required")
        },
        {
            type: "string",
            field: "features2",
            title: t("features2"),
            validate: rowData => rowData.features2 ? true : t("required")
        },
        {
            type: "string",
            field: "features3",
            title: t("features3"),
            validate: rowData => rowData.features3 ? true : t("required")
        },
        {
            field: "days",
            type: "numeric",
            title: t("DAYS"),
            validate: rowData =>
                rowData.days && !isNaN(rowData.days) && rowData.days > 0
                    ? true
                    : t("positive_required")
        },
        {
            field: "price",
            type: "string",
            title: t("PRICE"),
            validate: rowData =>
                rowData.price && !isNaN(rowData.price) && rowData.price > 0
                    ? true
                    : t("positive_required")
        }
    ];

    return (
        <CustomMaterialTable
            title={"plans"}
            columns={columns}
            data={plans.date ?? []}
            isLoading={plans.loading}
            editable={{
                onRowAdd: (newData) =>
                    settings?.AllowCriticalEditsAdmin
                        ? new Promise((resolve) => {
                            setTimeout(() => {

                                newData["createdAt"] = new Date().getTime();
                                dispatch(editPlans(newData, "Add"));
                                resolve("");
                            }, 600);
                        })
                        : new Promise((resolve) => {
                            setTimeout(() => {
                                resolve("");
                                alert(t("demo_mode"));
                            }, 600);
                        })
                ,
                onRowUpdate: (newData) =>
                    settings?.AllowCriticalEditsAdmin
                        ? new Promise((resolve) => {
                            setTimeout(() => {
                                delete (newData as any).tableData;
                                dispatch(editPlans(newData, "Update"));
                                resolve("");
                            }, 600);
                        })
                        : new Promise((resolve) => {
                            setTimeout(() => {
                                resolve("");
                                alert(t("demo_mode"));
                            }, 600);
                        }),
                onRowDelete: (oldData) =>
                    settings?.AllowCriticalEditsAdmin
                        ? new Promise((resolve) => {
                            setTimeout(() => {
                                dispatch(editPlans(oldData, "Delete"));
                            }, 600);
                            resolve("")
                        })
                        : new Promise((resolve) => {
                            setTimeout(() => {
                                resolve("");
                                alert(t("demo_mode"));
                            }, 600);
                        }),
            }}
        />
    );

}